var render = function render(){var _vm=this,_c=_vm._self._c;return _c('static-content-wrapper',{attrs:{"designer":_vm.designer,"field":_vm.field,"design-state":_vm.designState,"parent-widget":_vm.parentWidget,"parent-list":_vm.parentList,"index-of-parent-list":_vm.indexOfParentList,"sub-form-row-index":_vm.subFormRowIndex,"sub-form-col-index":_vm.subFormColIndex,"sub-form-row-id":_vm.subFormRowId}},[_c('div',{ref:"fieldEditor",style:({
    'font-size': !!_vm.field.options.fontSize ? _vm.field.options.fontSize : '',
    'text-align': _vm.field.options.contentPosition
  })},[_vm._v(" "+_vm._s(_vm.field.options.textContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }